import React from "react";
import { Modal, Button } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiShapeOutline, mdiEyeOffOutline, mdiArchiveOutline } from "@mdi/js";

const EditHowItWorksModal = ({ show, onHide }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Body className="pt-0 pb-2">
        <Modal.Header className="modal-title-with-border" closeButton>
          <Modal.Title>How It Works</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-1 px-2">
          <div className="d-flex flex-column gap-4 p-0">
            <div className="d-flex align-items-start gap-3">
              <div className="d-flex align-items-center justify-content-center">
                <Icon
                  path={mdiShapeOutline}
                  size={1.3}
                  color="#0D6EFD"
                  className="mt-1"
                />
              </div>
              <div>
                <p>
                  AI auto-categorizes your project content based on this
                  structure.
                </p>
              </div>
            </div>
            <div className="d-flex align-items-start gap-3">
              <div className="d-flex align-items-center justify-content-center">
                <Icon
                  path={mdiArchiveOutline}
                  size={1.3}
                  color="#0D6EFD"
                  className="mt-1"
                />
              </div>
              <div>
                <p>
                  The ”Other” section and subsection are fallback options for AI
                  and cannot be removed.
                </p>
              </div>
            </div>
            <div className="d-flex align-items-start gap-3">
              <div className="d-flex align-items-center justify-content-center">
                <Icon
                  path={mdiEyeOffOutline}
                  size={1.3}
                  color="#0D6EFD"
                  className="mt-1"
                />
              </div>
              <div>
                <p>
                  Sections with no content will be hidden in the final report.
                </p>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={onHide}
            className="px-4 py-2 fw-medium"
            style={{ minWidth: "100px" }}
          >
            Got it
          </Button>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
};

export default EditHowItWorksModal;
